/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SiteType } from '../models/site-type';
import { SearchSource } from '../models/search-source';
import { DataAnalysisTimeSeries } from '../models/data-analysis-time-series';
import { TimeSeriesDetailRequest } from '../models/time-series-detail-request';
import { TagMatch } from '../models/tag-match';
import { SeriesEvent } from '../models/series-event';
import { TimeSeriesDetailResponse } from '../models/time-series-detail-response';
import { DataDownloadRequest } from '../models/data-download-request';
import { TransformDetail } from '../models/transform-detail';
@Injectable({
  providedIn: 'root',
})
class DataService extends __BaseService {
  static readonly DataGetSiteTypesPath = '/api/Data/GetSiteTypes/{customerId}';
  static readonly DataSearchPath = '/api/Data/Search/{customerId}/{searchSize}/{pageIndex}/{includeAlarms}/{filterOld}';
  static readonly DataGetDataPath = '/api/Data/GetData/{customerId}';
  static readonly DataGetTagMatchesPath = '/api/Data/GetTagMatches/{customerId}/{siteType}/{max}';
  static readonly DataGetDataForMatchPath = '/api/Data/GetDataForMatch/{customerId}';
  static readonly DataDashboardGetsPath = '/api/Data/DashboardGets/{customerId}/{dashboardId}';
  static readonly DataUpdatePath = '/api/Data/Update/{customerId}';
  static readonly DataDownloadDataPath = '/api/Data/DownloadData';
  static readonly DataGetSimpleTransformsPath = '/api/Data/GetSimpleTransforms';
  static readonly DataGetTransformsPath = '/api/Data/GetTransforms';
  static readonly DataGetStorageSizePath = '/api/Data/GetStorageSize/{customerId}';
  static readonly DataGetConnectionStringPath = '/api/Data/GetConnectionString/{customerId}/{validForDays}';
  static readonly DataProxyPath = '/api/Data/Proxy';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param customerId undefined
   */
  DataGetSiteTypesResponse(customerId: number): __Observable<__StrictHttpResponse<Array<SiteType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Data/GetSiteTypes/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SiteType>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DataGetSiteTypes(customerId: number): __Observable<Array<SiteType>> {
    return this.DataGetSiteTypesResponse(customerId).pipe(
      __map(_r => _r.body as Array<SiteType>)
    );
  }

  /**
   * @param params The `DataService.DataSearchParams` containing the following parameters:
   *
   * - `searchSize`:
   *
   * - `pageIndex`:
   *
   * - `includeAlarms`:
   *
   * - `filterOld`:
   *
   * - `customerId`:
   *
   * - `type`:
   *
   * - `search`:
   */
  DataSearchResponse(params: DataService.DataSearchParams): __Observable<__StrictHttpResponse<Array<SearchSource>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;





    if (params.type != null) __params = __params.set('type', params.type.toString());
    if (params.search != null) __params = __params.set('search', params.search.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Data/Search/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.searchSize))}/${encodeURIComponent(String(params.pageIndex))}/${encodeURIComponent(String(params.includeAlarms))}/${encodeURIComponent(String(params.filterOld))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SearchSource>>;
      })
    );
  }
  /**
   * @param params The `DataService.DataSearchParams` containing the following parameters:
   *
   * - `searchSize`:
   *
   * - `pageIndex`:
   *
   * - `includeAlarms`:
   *
   * - `filterOld`:
   *
   * - `customerId`:
   *
   * - `type`:
   *
   * - `search`:
   */
  DataSearch(params: DataService.DataSearchParams): __Observable<Array<SearchSource>> {
    return this.DataSearchResponse(params).pipe(
      __map(_r => _r.body as Array<SearchSource>)
    );
  }

  /**
   * @param params The `DataService.DataGetDataParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   */
  DataGetDataResponse(params: DataService.DataGetDataParams): __Observable<__StrictHttpResponse<DataAnalysisTimeSeries>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Data/GetData/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataAnalysisTimeSeries>;
      })
    );
  }
  /**
   * @param params The `DataService.DataGetDataParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   */
  DataGetData(params: DataService.DataGetDataParams): __Observable<DataAnalysisTimeSeries> {
    return this.DataGetDataResponse(params).pipe(
      __map(_r => _r.body as DataAnalysisTimeSeries)
    );
  }

  /**
   * @param params The `DataService.DataGetTagMatchesParams` containing the following parameters:
   *
   * - `tagMatches`:
   *
   * - `siteType`:
   *
   * - `max`:
   *
   * - `customerId`:
   */
  DataGetTagMatchesResponse(params: DataService.DataGetTagMatchesParams): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.tagMatches;



    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Data/GetTagMatches/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteType))}/${encodeURIComponent(String(params.max))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @param params The `DataService.DataGetTagMatchesParams` containing the following parameters:
   *
   * - `tagMatches`:
   *
   * - `siteType`:
   *
   * - `max`:
   *
   * - `customerId`:
   */
  DataGetTagMatches(params: DataService.DataGetTagMatchesParams): __Observable<Array<string>> {
    return this.DataGetTagMatchesResponse(params).pipe(
      __map(_r => _r.body as Array<string>)
    );
  }

  /**
   * @param params The `DataService.DataGetDataForMatchParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   */
  DataGetDataForMatchResponse(params: DataService.DataGetDataForMatchParams): __Observable<__StrictHttpResponse<Array<SeriesEvent>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Data/GetDataForMatch/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SeriesEvent>>;
      })
    );
  }
  /**
   * @param params The `DataService.DataGetDataForMatchParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   */
  DataGetDataForMatch(params: DataService.DataGetDataForMatchParams): __Observable<Array<SeriesEvent>> {
    return this.DataGetDataForMatchResponse(params).pipe(
      __map(_r => _r.body as Array<SeriesEvent>)
    );
  }

  /**
   * @param params The `DataService.DataDashboardGetsParams` containing the following parameters:
   *
   * - `requests`:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DataDashboardGetsResponse(params: DataService.DataDashboardGetsParams): __Observable<__StrictHttpResponse<Array<TimeSeriesDetailResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.requests;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Data/DashboardGets/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.dashboardId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TimeSeriesDetailResponse>>;
      })
    );
  }
  /**
   * @param params The `DataService.DataDashboardGetsParams` containing the following parameters:
   *
   * - `requests`:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  DataDashboardGets(params: DataService.DataDashboardGetsParams): __Observable<Array<TimeSeriesDetailResponse>> {
    return this.DataDashboardGetsResponse(params).pipe(
      __map(_r => _r.body as Array<TimeSeriesDetailResponse>)
    );
  }

  /**
   * @param params The `DataService.DataUpdateParams` containing the following parameters:
   *
   * - `updatedData`:
   *
   * - `customerId`:
   */
  DataUpdateResponse(params: DataService.DataUpdateParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.updatedData;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Data/Update/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `DataService.DataUpdateParams` containing the following parameters:
   *
   * - `updatedData`:
   *
   * - `customerId`:
   */
  DataUpdate(params: DataService.DataUpdateParams): __Observable<Blob> {
    return this.DataUpdateResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  DataDownloadDataResponse(request: DataDownloadRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Data/DownloadData`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  DataDownloadData(request: DataDownloadRequest): __Observable<Blob> {
    return this.DataDownloadDataResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  DataGetSimpleTransformsResponse(): __Observable<__StrictHttpResponse<Array<TransformDetail>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Data/GetSimpleTransforms`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TransformDetail>>;
      })
    );
  }  DataGetSimpleTransforms(): __Observable<Array<TransformDetail>> {
    return this.DataGetSimpleTransformsResponse().pipe(
      __map(_r => _r.body as Array<TransformDetail>)
    );
  }
  DataGetTransformsResponse(): __Observable<__StrictHttpResponse<Array<TransformDetail>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Data/GetTransforms`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TransformDetail>>;
      })
    );
  }  DataGetTransforms(): __Observable<Array<TransformDetail>> {
    return this.DataGetTransformsResponse().pipe(
      __map(_r => _r.body as Array<TransformDetail>)
    );
  }

  /**
   * @param customerId undefined
   */
  DataGetStorageSizeResponse(customerId: number): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Data/GetStorageSize/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: parseFloat((_r as HttpResponse<any>).body as string) }) as __StrictHttpResponse<number>
      })
    );
  }
  /**
   * @param customerId undefined
   */
  DataGetStorageSize(customerId: number): __Observable<number> {
    return this.DataGetStorageSizeResponse(customerId).pipe(
      __map(_r => _r.body as number)
    );
  }

  /**
   * @param params The `DataService.DataGetConnectionStringParams` containing the following parameters:
   *
   * - `validForDays`:
   *
   * - `customerId`:
   */
  DataGetConnectionStringResponse(params: DataService.DataGetConnectionStringParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Data/GetConnectionString/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.validForDays))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `DataService.DataGetConnectionStringParams` containing the following parameters:
   *
   * - `validForDays`:
   *
   * - `customerId`:
   */
  DataGetConnectionString(params: DataService.DataGetConnectionStringParams): __Observable<string> {
    return this.DataGetConnectionStringResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param url undefined
   */
  DataProxyResponse(url?: null | string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (url != null) { __formData.append('url', url as unknown as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Data/Proxy`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param url undefined
   */
  DataProxy(url?: null | string): __Observable<string> {
    return this.DataProxyResponse(url).pipe(
      __map(_r => _r.body as string)
    );
  }
}

module DataService {

  /**
   * Parameters for DataSearch
   */
  export interface DataSearchParams {
    searchSize: number;
    pageIndex: number;
    includeAlarms: boolean;
    filterOld: boolean;
    customerId: number;
    type?: null | string;
    search?: null | string;
  }

  /**
   * Parameters for DataGetData
   */
  export interface DataGetDataParams {
    request: TimeSeriesDetailRequest;
    customerId: number;
  }

  /**
   * Parameters for DataGetTagMatches
   */
  export interface DataGetTagMatchesParams {
    tagMatches: Array<TagMatch>;
    siteType: string;
    max: number;
    customerId: number;
  }

  /**
   * Parameters for DataGetDataForMatch
   */
  export interface DataGetDataForMatchParams {
    request: TimeSeriesDetailRequest;
    customerId: number;
  }

  /**
   * Parameters for DataDashboardGets
   */
  export interface DataDashboardGetsParams {
    requests: Array<TimeSeriesDetailRequest>;
    dashboardId: number;
    customerId: number;
  }

  /**
   * Parameters for DataUpdate
   */
  export interface DataUpdateParams {
    updatedData: DataAnalysisTimeSeries;
    customerId: number;
  }

  /**
   * Parameters for DataGetConnectionString
   */
  export interface DataGetConnectionStringParams {
    validForDays: number;
    customerId: number;
  }
}

export { DataService }
